module.exports = __webpack_public_path__ + "media/images/Edit-black-2f5e681b853a61b31525e7d7e902b881.svg";